// extracted by mini-css-extract-plugin
module.exports = {"partners-landing-container":"PartnersLanding_partners-landing-container__1TphB","list-of-partners":"PartnersLanding_list-of-partners__3-7T1"};